import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalSearchResponse, SearchResultItem } from '../models/global-search.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private apiUrl = `${environment.apiBaseUrl}/api/v1`;

  // Last search term/results, kept here (not on the component) so they survive
  // navigating away to a search result and back to /home without a re-fetch.
  private cachedSearchTerm = '';
  private cachedSearchResults: SearchResultItem[] = [];

  private get jsonHeaders() {
    return {
      'accept': 'application/json'
    };
  }

  constructor(private http: HttpClient) {}

  /**
   * Search for document models, fields, and evaluation files
   * @param q - Search term (minimum 2 characters required by API)
   * @param clientId - Client ID to scope search to a specific client
   * @returns Observable of search results grouped by type
   */
  searchGlobal(q: string, clientId: string): Observable<GlobalSearchResponse> {
    const params = new HttpParams()
      .set('q', q)
      .set('client_id', clientId);

    return this.http.get<GlobalSearchResponse>(
      `${this.apiUrl}/eval/search`,
      { headers: this.jsonHeaders, params }
    );
  }

  /**
   * Cache the results of the last successful search so they can be restored
   * without a new API call (e.g. when the user navigates back to /home).
   */
  cacheSearchResults(term: string, results: SearchResultItem[]): void {
    this.cachedSearchTerm = term;
    this.cachedSearchResults = results;
  }

  getCachedSearchResults(): { term: string; results: SearchResultItem[] } {
    return { term: this.cachedSearchTerm, results: this.cachedSearchResults };
  }

  clearCachedSearchResults(): void {
    this.cachedSearchTerm = '';
    this.cachedSearchResults = [];
  }
}
